<!-- ADD-MODAL-STRUCTURE -->
<div class="master-modal" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <!-- Modal-Header -->
        <!-- <div class="modal_close_btn">
          <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
        </div> -->
        <!-- Modal content-->
        <div mat-dialog-content> 
          <!-- Modal-Body -->
          <div class="modal-body br-8">
            <div class="modal_close_btn">
              <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
            </div>
            <div class="profile_complition_details">
              <div class="status_img">
                <img src="../../../../../assets/images/profile_complition.jpg" alt="">
              </div>
              <div class="status_content">
                <h2>Your Profile is incomplete.</h2>
                <p>Please Complete your Profile / Subcription
                  To access your Service</p>
                <div fxLayout="column" fxLayoutAlign="center center">
                  <!-- <button class="btn btn-sm global-btn" (click)="dialogClose()" mat-button [routerLink]="['/sign-up',data?.present_subscription_id,data?.id]">Continue</button> -->
                  <!-- <button class="btn btn-sm global-btn" (click)="dialogClose()" mat-button [routerLink]="['/sign-up',data?.present_subscription_id,data?.id]">Continue</button> -->
                  <button class="btn btn-sm global-btn" (click)="dialogClose()" mat-button>Continue</button> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
